module.exports = __webpack_public_path__ + "img/titel.6692924d.jpg";